module.exports = __webpack_public_path__ + "img/Img10_204733_CeEu-12-1388.28dc5966.jpg";